import { ReactNode } from "react"
import { FiLoader } from "react-icons/fi"

type SpinnerProps = {
  size?: number
  className?: string
}

// Inherits the text colour, so it fits buttons, toasts and plain text alike
export default function Spinner({ size = 16, className = "" }: SpinnerProps) {
  return (
    <FiLoader
      size={size}
      className={`inline-block shrink-0 animate-spin ${className}`}
      aria-hidden="true"
    />
  )
}

// A short status text with the spinner in front of it
export function SpinnerText({ children }: { children: ReactNode }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <Spinner size={14} />
      {children}
    </span>
  )
}
